const MovieSubtitle = ({text}) => (
    <h3 className="movie-subtitle text-center">
        {text}   
    </h3>
)


export default MovieSubtitle
